import { Box } from '@mui/material';
import { createPortal } from 'react-dom';
import { useWatch } from 'react-hook-form';

import { RemarkButton } from '@Components/IconButton';
import { useDisclosure } from '@hooks/useDisclosure';

import {
  IImpactsOnStakeholdersFormValues,
  StakeholderAnalysisFormValues,
} from '../ImpactsOnStakeholdersFormProvider/types';
import { useImpactsOnStakeholdersForm } from '../ImpactsOnStakeholdersFormProvider';
import Remark from '@Components/Remark';

export const STAKEHOLDER_ANALYSIS_REMARK_ID = 'stk-analysis-remark';

const StakeholderAnalysisRemark = () => {
  const { control, getValues } = useImpactsOnStakeholdersForm();

  const { remark } =
    getValues(`stakeholderAnalysis`) ??
    ({} as IImpactsOnStakeholdersFormValues);

  const [isRemarkOpen, { open, close }] = useDisclosure(!!remark);

  const stkAnalysisRemarkEl = document.getElementById(
    STAKEHOLDER_ANALYSIS_REMARK_ID
  );

  const { completedSection } =
    useWatch({
      name: 'stakeholderAnalysis',
      control,
    }) ?? ({} as StakeholderAnalysisFormValues);

  const { isCompletedTh = false, isCompletedEn = false } =
    completedSection ?? {};

  return (
    <>
      <RemarkButton onClick={open} disabled={isCompletedTh && isCompletedEn} />
      {isRemarkOpen &&
        stkAnalysisRemarkEl &&
        createPortal(
          <Box mt={2}>
            <Remark
              onDelete={close}
              topic="การวิเคราะห์ผู้มีส่วนได้เสียในห่วงโซ่คุณค่าของธุรกิจ"
              setOpen={open}
              fieldPath="stakeholderAnalysis.remark"
              isCompletedEn={isCompletedEn}
              isCompletedTh={isCompletedTh}
            />
          </Box>,
          stkAnalysisRemarkEl
        )}
    </>
  );
};

export default StakeholderAnalysisRemark;
